$(document).ready(function(){
document.querySelectorAll("div[data-slider]").forEach(sliderContainer2 => {
            const slider = sliderContainer2.querySelector(".uness-slider-2");
            const prevBtn = sliderContainer2.querySelector(".uness-prev-2");
            const nextBtn = sliderContainer2.querySelector(".uness-start-2");

            function slideNext() {
                const firstSlide = slider.firstElementChild;
                slider.appendChild(firstSlide);
            }

            function slidePrev() {
                const lastSlide = slider.lastElementChild;
                slider.insertBefore(lastSlide, slider.firstElementChild);
            }
            prevBtn.addEventListener("click", slidePrev);
            nextBtn.addEventListener("click", slideNext);
        });
    $('.collection-filters__filter-link[data-value="White"]').append(" <span class='uness-colours' style='background-color:#fdfff2;'></span>"); 
  $('.collection-filters__filter-link[data-value="Orange"]').append(" <span class='uness-colours' style='background-color:#de8042;'></span>"); 
  $('.collection-filters__filter-link[data-value="Beige"]').append(" <span class='uness-colours' style='background-color:#BFB3A7;'></span>"); 
  $('.collection-filters__filter-link[data-value="Mocca"]').append(" <span class='uness-colours' style='background-color:#9A8F87;'></span>"); 
   $('.collection-filters__filter-link[data-value="Silver"]').append(" <span class='uness-colours' style='background-color:#CBC8C3;'></span>"); 
  $('.collection-filters__filter-link[data-value="Red"]').append(" <span class='uness-colours' style='background-color:#781925;'></span>");
  $('.collection-filters__filter-link[data-value="Black"]').append(" <span class='uness-colours' style='background-color:black;'></span>");
  $('.collection-filters__filter-link[data-value="Dark Grey"]').append(" <span class='uness-colours' style='background-color:#625b5b;'></span>");
  $('.collection-filters__filter-link[data-value="Grey"]').append(" <span class='uness-colours' style='background-color:grey;'></span>");
  $('.collection-filters__filter-link[data-value="Blue"]').append(" <span class='uness-colours' style='background-color:#03579c;'></span>");
  $('.collection-filters__filter-link[data-value="Cream"]').append(" <span class='uness-colours' style='background-color:#D6D3BF;'></span>");
   $('.collection-filters__filter-link[data-value="Light Grey"]').append(" <span class='uness-colours' style='background-color:#c8c8c8;'></span>");
  $('.collection-filters__filter-link[data-value="Light Green"]').append(" <span class='uness-colours' style='background-color:#8c9a82;'></span>");
  $('.collection-filters__filter-link[data-value="Tan"]').append(" <span class='uness-colours' style='background-color:#b58065;'></span>");
  $('.collection-filters__filter-link[data-value="Brown"]').append(" <span class='uness-colours' style='background-color:#6d5b4c;'></span>");
  $('.collection-filters__filter-link[data-value="Purple"]').append(" <span class='uness-colours' style='background-color:#763b41;'></span>");
  $('.collection-filters__filter-link[data-value="Turquoise"]').append(" <span class='uness-colours' style='background-color:#33444f;'></span>");
   $('.collection-filters__filter-link[data-value="Pink"]').append(" <span class='uness-colours' style='background-color:#876e69;'></span>");
   $('.collection-filters__filter-link[data-value="Green"]').append(" <span class='uness-colours' style='background-color:#6f877a;'></span>");
   $('.collection-filters__filter-link[data-value="Mocha"]').append(" <span class='uness-colours' style='background-color:#8d7e77;'></span>"); 

$('.collection-filters__filter-link[data-value="Leather"]').append(" <img class='uness-material' src='https://cdn.shopify.com/s/files/1/0614/6464/1749/files/leather_c54d598b-d047-4893-a52d-d06e86ce4063.png' alt='Leather Icon' />");
  $('.collection-filters__filter-link[data-value="Fabric"]').append(" <img class='uness-material' src='https://cdn.shopify.com/s/files/1/0614/6464/1749/files/fabric_16c5f9cc-1b80-44dd-a335-b3db13bda92c.png' alt='Fabric Icon' />");
$('.collection-filters__filter-link[data-value="Manual"]').append(" <img class='uness-material' src='https://cdn.shopify.com/s/files/1/0614/6464/1749/files/manual.png?v=1743086375' alt='Manual Icon' />");
  $('.collection-filters__filter-link[data-value="Electric"]').append(" <img class='uness-material' src='https://cdn.shopify.com/s/files/1/0614/6464/1749/files/electric.png' alt='Electric Icon' />");


  
 function updateCartCount() {
  $.getJSON("/cart.js", function (data) {
    $(".cart-count").text(data.item_count);

    // Loop through all product cards
    $(".uness-prdct-related-item-content").each(function () {
      let parent = $(this);
      let productId = parent.find(".uness-btn-related").data("product-id");
      let inCart = data.items.some(item => item.variant_id == productId);

      if (inCart) {
        parent.find(".in_cart_show").css("display", "flex");
        parent.find(".uness-btn-related").css("display", "none");
      } else {
        parent.find(".in_cart_show").css("display", "none");
        parent.find(".uness-btn-related").css("display", "flex");
      }
    });
  });
}

$(".uness-btn-related").on("click", function (e) {
  e.preventDefault();
  let button = $(this);
  let productId = button.data("product-id");
  let quantity = 1;

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      id: productId,
      quantity: quantity
    },
    dataType: "json",
    success: function () {
      updateCartCount(); // This will handle UI updates
    },
    error: function (xhr, status, error) {
      console.error("Error adding to cart:", error);
    }
  });
});
$(document).ready(function () {
  updateCartCount();
});
});           
  window.addEventListener('load', () => {
  const gallery = document.querySelector('.pwzrjss1');
  if (gallery) {
    gallery.insertAdjacentHTML('afterend', '<center><span style="font-size:12px;">Please note that the Sofa Shop Logo in NOT Printed on The Product</span></center>');
  }
});
